import { render, staticRenderFns } from "./FilterTopSupplierItems.vue?vue&type=template&id=78a876e3&"
import script from "./FilterTopSupplierItems.vue?vue&type=script&lang=js&"
export * from "./FilterTopSupplierItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports